import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UserValidationService {

  constructor() { }

  registerFormValidation(data?: any): object {
    const validation: any = {
      firstname: new FormControl(data?.firstname || '', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]),
      lastname: new FormControl(data?.lastname || '', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]),
      email: new FormControl(data?.email || '', [Validators.required, Validators.maxLength(50), Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-z]{2,4}$")]),
      phone: [data?.phone || null, [Validators.required, Validators.maxLength(20)]],
      role: new FormControl('General', [Validators.required]),
      national_number: new FormControl(data?.national_number || '', []),
      resident_number: new FormControl(data?.resident_number || null, []),
      is_national_number: new FormControl(data ? data?.is_national_number : true),
      country_id: new FormControl(data?.country_id),
      region_id: new FormControl(data?.region_id),
      city: new FormControl(data?.city || null),
      street: new FormControl(data?.street || null),
      interests: new FormControl(data?.interests || null)
    };

    if (!data) {
      validation["password"] = new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)]);
    }
    return validation;
  }

  resetPassFormValidation(): object {
    const validation: object = {
      password: new FormControl(null, [Validators.required, Validators.maxLength(50), Validators.minLength(8), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)]),
      old_password: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      cPassword: new FormControl(null, [Validators.required, Validators.maxLength(50), Validators.minLength(8), Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)]),
    };
    return validation;
  }
}
